import { PageController } from '@client/components/_core/layout/PageController';
import { History } from '@client/components/_ui/display/History';
import { createFileRoute } from '@tanstack/react-router';
import { Tabs } from 'antd';
import { RiskAppetiteStatementManageDetails } from './RiskAppetiteStatementManageDetails';

export const Route = createFileRoute('/console/$orgId/risk/ras/details/$id')({
    staticData: {
        breadcrumb: {
            title: 'Risk appetite statement details',
        },
        ui: {
            widthVariant: 'default',
        },
    },
    params: {
        parse({ id }) {
            return {
                id: BigInt(id),
            };
        },
    },
    component: RiskAppetiteStatementDetails,
});

function RiskAppetiteStatementDetails() {
    const { id } = Route.useParams();

    return (
        <PageController route={Route}>
            <Tabs
                type="line"
                items={[
                    {
                        key: 'risk_appetite_statement_details',
                        label: 'Risk appetite statement details',
                        destroyOnHidden: true,
                        children: <RiskAppetiteStatementManageDetails />,
                    },
                    {
                        key: 'risk_appetite_statement_history',
                        label: 'History',
                        destroyOnHidden: true,
                        children: <History idValue={id} idPropertyName="riskAppetiteStatementId" />,
                    },
                ]}
            />
        </PageController>
    );
}
